import { CLEARTRIP, FLYIN } from '@/src/constants/buildVariants'
import { VariantType } from '@/src/utils/buildUtils'

type FeatureFlags =
    | 'MULTI_CITY'
    | 'VISA'
    | 'FLIGHTS_HOTELS'
    | 'TRENDING_DESTINATIONS'
    | 'TRENDING_HOTELS'
    | 'OLD_SIGNIN_FLOW'
    | 'TRAVEL_LICENSE_INFO'
    | 'APP_DOWNLOAD_BANNER'
    | 'GIFT_VOUCHER'
    | 'GOOGLE_SIGNIN'
    | 'EXPLORE_OTHER_LINKS'
    | 'TOP_DESTINATIONS'
    | 'TOP_COUNTRIES'
    | 'MULTI_DOMAIN_WALLET_BALANCE'

export type Features = {
    [K in FeatureFlags]: boolean
}

export const featureConfig: Record<VariantType, Partial<Features>> = {
    [FLYIN]: {
        MULTI_CITY: true,
        FLIGHTS_HOTELS: true,
        TRENDING_DESTINATIONS: true,
        TRENDING_HOTELS: true,
        TRAVEL_LICENSE_INFO: true,
        APP_DOWNLOAD_BANNER: true,
        GOOGLE_SIGNIN: true,
        TOP_DESTINATIONS: true,
        TOP_COUNTRIES: true,
        MULTI_DOMAIN_WALLET_BALANCE: true,
    },
    [CLEARTRIP]: {
        VISA: true,
        OLD_SIGNIN_FLOW: true,
        GIFT_VOUCHER: true,
        GOOGLE_SIGNIN: true,
        EXPLORE_OTHER_LINKS: true,
        TOP_COUNTRIES: true,
    }
}
